import { useState } from 'react'
import { Building2, ChevronDown, Check } from 'lucide-react'
import { useBranch, BRANCHES } from '@/providers/branch-provider'

export function BranchSelector() {
  const { selectedBranch, setSelectedBranch } = useBranch()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between gap-2 bg-card rounded-full px-3 py-2 sm:px-4 sm:py-2.5 min-w-[120px] sm:w-[180px] border border-border transition-all hover:bg-hover"
      >
        <div className="flex items-center gap-2">
          <Building2 className="w-4 h-4 sm:w-[18px] sm:h-[18px] text-foreground flex-shrink-0" />
          <span className="text-xs sm:text-[14px] font-normal text-text-dark truncate">{selectedBranch.name}</span>
        </div>
        <ChevronDown className={`w-4 h-4 sm:w-[18px] sm:h-[18px] text-foreground flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          {/* Backdrop to close on click outside */}
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
          <div className="absolute right-0 top-full mt-1 min-w-[140px] sm:w-[180px] rounded-lg border border-border bg-card p-1 shadow-lg z-50">
            {BRANCHES.map((branch) => (
              <button
                key={branch.id}
                onClick={() => {
                  setSelectedBranch(branch)
                  setIsOpen(false)
                }}
                className={`flex w-full items-center justify-between rounded-md px-3 py-2 text-[14px] transition-colors ${
                  selectedBranch.id === branch.id
                    ? 'bg-hover text-text-dark font-medium'
                    : 'text-text-dark hover:bg-hover'
                }`}
              >
                {branch.name}
                {selectedBranch.id === branch.id && (
                  <Check className="w-4 h-4 text-success" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
